import { ReactNode } from 'react';

export enum ListBoxView {
  Default,
  Primary, // for primary actions like create new contact
  Secondary, // for secondary actions like edit a contact from list
}

export type DefaultViewConfig = {
  content: ReactNode;
  primaryButtonLabel?: string;
  primaryButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  onAction?: () => void | Promise<void>;
  onCancel?: () => void;
};

export type PrimaryViewConfig = {
  title: string;
  content: ReactNode;
  primaryLabel?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  primaryButtonTrackingId?: string;
  cancelButtonTrackingId?: string;
  onAction: () => void | Promise<boolean | void>;
  onCancel: () => void;
};
